/**
 * Lucide visual set — same Fomantic-canonical name vocabulary as
 * `icons/fomantic.ts`, intended to ship Lucide-style glyphs. Currently a
 * content-identical alias of the Fomantic data while glyph divergence is
 * future work; the architecture is in place so consumers can opt in today
 * and the visual set diverges over time without an API change.
 *
 * Side-effect import:
 *
 *   import 'ry-ui/icons/lucide';
 *   setIconSet('lucide');
 *
 * When real Lucide-style glyphs land, replace the shared-data import with
 * an inline `Record<string, string>` here. Consumers who only import this
 * file then ship only Lucide glyphs — no Fomantic data in their bundle.
 */
import { registerSet } from '../core/ry-icons.js';
import { ICONS } from './_data.js';

registerSet('lucide', ICONS);
